import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {CriteriaStrip} from 'src/components/criteria-strip';
import {selectSearchRequest} from 'src/components/criteria-strip/services/criteria-strip-slice';
import {SEARCH_RESULT_TABS} from 'src/constants';
import {useEffectWithDeps} from 'src/hooks/useEffectWithDeps';
import {accountSearchResultStateActions} from 'src/modules/account-search-result';
import {isDeepEqual} from 'src/utils/isDeepEqual';

import Typography from '@pb/kit-component-typography';

import {
    searchCriteria,
    searchCriteriaHeader,
    searchCriteriaStripContainer,
} from '../../search-criteria.module.styl';
import {SearchButton} from '../search-button/search-button';

import {AccountSearch} from './account-search';


type Props = {
    searchId: string,
};

export const AccountSearchCriteria = ({searchId}: Props) => {
    const dispatch = useDispatch();
    const searchRequest = useSelector(selectSearchRequest);

    useEffect(() => {
        if (searchRequest) {
            dispatch(accountSearchResultStateActions.setSearchCriteria(searchRequest));
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffectWithDeps((prev, current) => {
        if (current.searchRequest && !isDeepEqual({prev, current})) {
            dispatch(accountSearchResultStateActions.setSearchCriteria(current.searchRequest));
        }
    }, {searchRequest});

    return (
        <div className={searchCriteria}>
            <header className={searchCriteriaHeader}>
                <Typography variant="heading-level-1">Accounts & Users Search</Typography>
                <SearchButton activeTab={SEARCH_RESULT_TABS.ACCOUNTS} searchId={searchId}/>
            </header>
            <div className={searchCriteriaStripContainer}>
                <CriteriaStrip activeTab={SEARCH_RESULT_TABS.ACCOUNTS} showClear={true}/>
            </div>
            <AccountSearch/>
        </div>
    );
};
